import Calendar from '../Models/Calendar';

export const EventTypeFilterControls = (calendar) => {
    if (!(calendar instanceof Calendar)) {
        throw Error('param must be a Whale Calendar Instance!');
    }
    const container = document.createElement('div');
    container.classList = 'whale-calendar-filter-container btn-group';

    const { eventTypes } = calendar;
    const eventCheckboxes = Object.entries(eventTypes).map((entry) => {
        const type = entry[0];
        const visible = entry[1];
        const button = document.createElement('button');
        button.classList = 'whale-calendar-type-control btn btn-sm btn-default active checkbox';
        button.id = type;
        button.type = 'button';
        button.value = type;
        button.textContent = type;
        button.addEventListener('click', function() {
            this.classList.toggle('active');
            calendar.eventTypes[type] = this.classList.contains('active');
            calendar.filterEvents();
        })
        container.append(button);
        return button;
    })

    return container;
}
